export default __webpack_public_path__ + "static/media/publish.c1699727.png";